import { render, staticRenderFns } from "./NewInternship.vue?vue&type=template&id=605193a7&"
import script from "./NewInternship.vue?vue&type=script&lang=js&"
export * from "./NewInternship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports